import React, { useMemo } from 'react';
import { Check } from 'lucide-react';
import { ElementsRenderer } from '../shared';
import { AssignmentReviewOption } from './AssignmentReviewOption';
import { cn } from '../ui/utils';

const getQuestionPlainText = (elements = []) =>
  elements
    .map((el) => (el.html ? el.html.replace(/<[^>]+>/g, ' ') : ''))
    .join(' ')
    .toLowerCase();

const MCQReview = ({ question, response, answerStatus }) => {
  const { options, elements, solution } = question;
  const { answer } = response;

  const isMultipleChoice = useMemo(
    () => getQuestionPlainText(elements).includes('select all that apply'),
    [elements]
  );

  const selectedAnswers = useMemo(() => {
    if (!Array.isArray(answer)) return [];
    return answer.filter(Boolean);
  }, [answer]);

  const selectedSingle = answer?.[0] || null;

  const isSelected = (optionId) =>
    isMultipleChoice ? selectedAnswers.includes(optionId) : selectedSingle === optionId;

  return (
    <div className="katex-question w-full space-y-4 md:space-y-6">
      <div className="question-container space-y-3 md:space-y-4">
        <div className="text-base leading-relaxed text-foreground md:text-lg">
          <ElementsRenderer elements={elements} />
        </div>
        {isMultipleChoice && (
          <p className="text-sm italic text-muted-foreground">Select all that apply:</p>
        )}
      </div>

      <div className="space-y-3">
        {options?.map((option) => {
          const selected = isSelected(option.id);

          return (
            <AssignmentReviewOption
              key={option.id}
              {...option}
              studentSelected={selected}
              isMultipleChoice={isMultipleChoice}
              answerStatus={answerStatus}
            />
          );
        })}
      </div>

      {solution?.elements?.length > 0 && (
        <div className="space-y-3 border-t border-border/60 pt-4">
          <h4 className="font-medium text-foreground">Detailed Solution</h4>
          <div className="text-sm leading-relaxed text-muted-foreground">
            <ElementsRenderer elements={solution.elements} />
          </div>
        </div>
      )}
    </div>
  );
};

export default MCQReview;
